import React, { useState } from 'react';
import moment from 'moment';

import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

const displayDate = (d) => {
  const m = moment(d);

  return m.diff(new Date(), 'd') === 0
    ? '今天'
    : m.format('YYYY.MM.DD');
};

const DayRangePicker = ({
  range: { from, to },
  onChange = () => {},
}) => {
  const [show, setShow] = useState(false);
  const [selecting, setSelecting] = useState(null);

  return (
    <span className="position-relative">
      <button
        className="btn btn-sm border"
        onClick={() => setShow(!show)}
      >
        {displayDate(from)} - {displayDate(to)}
      </button>
      {show && (
        <div
          className="position-absolute border bg-white mt-2 pt-3 px-3"
          style={{ zIndex: 100 }}
        >
          <DayPicker
            className="Selectable"
            selectedDays={
              selecting ? [selecting] : [from, { from, to }]
            }
            modifiers={{ start: from, end: to }}
            onDayClick={(date) => {
              const d = moment(date).startOf('d').toDate();

              if (selecting) {
                setSelecting(null);
                onChange({
                  from: selecting,
                  to: d,
                });
              } else {
                setSelecting(d);
              }
            }}
          />
        </div>
      )}
    </span>
  );
};

export default DayRangePicker;
